"use client";

import { useState } from "react";
import Button from "@components/atoms/Button";
import Image from "@components/atoms/Image";
import assetLoader from "@utils/internalImageLoder";
import styles from "../ExpertRatingsBackground.module.scss";

interface ClientWrapperProps {
  htmlContent: string;
}

export default function ExpertRatingsClientWrapper({
  htmlContent,
}: ClientWrapperProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.summarisedReviewWrapper}>
      <div
        className={`${styles.reviewContent} ${
          expanded ? styles.expanded : styles.collapsed
        }`}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />

      {!expanded && (
        <Button
          className={styles.readMoreButton}
          onButtonClick={() => setExpanded(true)}
        >
          <span>Read more</span>
          <Image
            src={`${assetLoader()}/icons/expertReview/Chevron_down.svg`}
            alt="Read More"
            className={styles.chevronDown}
            width={20}
            height={20}
            loading="lazy"
          />
        </Button>
      )}
    </div>
  );
}
